import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Globe2, BadgeCheck, Plane } from "lucide-react";
import { SecurePaymentsPanel } from "@/components/PaymentMethods";

const ITEMS = [
  { icon: ShieldCheck, t: "Registered in UAE", flag: "🇦🇪" },
  { icon: ShieldCheck, t: "Registered in Zimbabwe", flag: "🇿🇼" },
  { icon: ShieldCheck, t: "Registered in South Africa", flag: "🇿🇦" },
  { icon: Globe2, t: "Worldwide Travel Solutions" },
  { icon: BadgeCheck, t: "International Travel Specialists" },
];

const STRIP = [
  { flag: "🇦🇪", t: "Registered in UAE" },
  { flag: "🇿🇼", t: "Registered in Zimbabwe" },
  { flag: "🇿🇦", t: "Registered in South Africa" },
  { icon: Globe2, t: "Worldwide Travel Solutions" },
  { icon: Plane, t: "International Travel Specialists" },
];

const fadeUp = {
  initial: { opacity: 0, y: 14 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-40px" },
  transition: { duration: 0.55, ease: "easeOut" },
};

export const TrustStrip = () => (
  <section className="pt-12 pb-14 bg-white border-b border-[#E5E7EB]" data-testid="trust-strip">
    <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap justify-center gap-x-12 gap-y-5">
      {ITEMS.map((it) => (
        <div key={it.t} className="flex items-center gap-2.5 text-[13px] font-semibold tracking-wide text-[#0A2E4D]">
          <it.icon size={17} className="text-[#D4A62A] shrink-0" strokeWidth={1.8} />
          <span>{it.t}</span> {it.flag && <span aria-hidden className="text-sm leading-none">{it.flag}</span>}
        </div>
      ))}
    </motion.div>

    <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12" data-testid="home-payment-methods">
      <SecurePaymentsPanel />
    </motion.div>

    <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10" data-testid="international-trust-strip">
      <div className="flex flex-wrap items-center justify-center gap-y-3 text-[12px] font-semibold tracking-wide text-[#4B5563]">
        {STRIP.map((it, i) => (
          <React.Fragment key={it.t}>
            {i > 0 && <span aria-hidden className="mx-4 sm:mx-5 text-[#D1D5DB] select-none hidden sm:inline">·</span>}
            <span className="inline-flex items-center gap-1.5 px-3 sm:px-0">
              {it.flag ? <span aria-hidden className="text-sm leading-none">{it.flag}</span> : <it.icon size={14} className="text-[#D4A62A]" strokeWidth={2} />}
              {it.t}
            </span>
          </React.Fragment>
        ))}
      </div>
    </motion.div>
  </section>
);
